import React from "react";

interface VerticalLinesBackgroundProps {
  lines?: number;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
  containerClassName?: string; // جديد
}

const VerticalLinesBackground: React.FC<VerticalLinesBackgroundProps> = (props) => {
  const {
    lines = 4,
    color = "#B8B093",
    className = "",
    style = {},
    containerClassName = "max-w-[1440px] mx-auto px-4 md:px-10 h-full w-full", // افتراضي مثل أغلب السكشنز
  } = props;
  return (
    <div
      className={`absolute inset-0 z-0 pointer-events-none w-full h-full ${className}`}
      style={style}
      aria-hidden="true"
    >
      <div className={containerClassName + " flex h-full w-full"}>
        {Array.from({ length: lines }).map((_, i) => (
          <div
            key={i}
            className="flex-1 h-full"
            style={{
              borderRight: i < lines - 1 ? `1px solid ${color}` : undefined,
              height: "100%",
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default VerticalLinesBackground;
